module.exports = __webpack_public_path__ + "static/media/STORE WITH US.4c3ec779.jpg";